var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_content lg:flex items-center"},[_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.value[0]))+":\n    ")]),_c('div',{staticClass:"val"},[_vm._v("\n        "+_vm._s(_vm.meaning)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }